import React, { useState, useEffect } from 'react';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';


import {connect} from 'react-redux';
import * as actions from '../../store/project/actions';
import ProjectCardLandscap from './projectCardLandscap';
import ProjectCardPortrait from './projectCardPortrait';





const FeaturedProjectResidential = ({getResFeaturedProjects, featuredResProjects}) => {   

    
    useEffect(() => {
		loadData();
	},[]);

    const loadData = async() => {
        await getResFeaturedProjects({
            project_type: "Residential", // "Commercial",
            // project_type_id: 1,
            is_featured: 1,
            no_of_projects: 5}).then(res => {
            
        })
    }

    // console.log('featuredResProjects', featuredResProjects)
    const getProjectBoxLandscap = (project, projectIndex) => {
        console.log(project)
        if(projectIndex == 0 ){
            return <Col xl={4}>
                        <ProjectCardLandscap project={project} />
                    </Col>
        } else {

        }
    }

    const getProjectBoxPortrait = (project, projectIndex) => {
        return <Col md={6} key={`reFeaturedProjects${projectIndex}`}>
            <ProjectCardPortrait project={project} />
        </Col>
    }
    
    return (
        <section className='pt-5 pb-5 featuredBox'>
                <Container>
                    <h3 className="text-center mb-4">Feature Project Residential</h3>
                    <Row>
                        {
                            featuredResProjects && featuredResProjects.projects && featuredResProjects.projects.length > 0 ? 
                                    getProjectBoxLandscap(featuredResProjects.projects[0], 0)
                            : ''
                        }
                        
                        <Col xl={8}>
                            <Row>
                            {

                                featuredResProjects && featuredResProjects.projects && featuredResProjects.projects.length > 0 ? 
                                    featuredResProjects.projects.map((project, projectIndex) => {
                                        return projectIndex == 0 ? null : getProjectBoxPortrait(project, projectIndex)
                                    })
                                : ''
                            }
                                
                                
                            </Row>
                        </Col>
                    </Row>
                    <div className='text-center'><Button href="#">See All Properties</Button></div>
                </Container>
            </section>
    )
}
function mapStateToProps(state) {
    return {
        featuredResProjects: state.project.featuredResProjects
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getResFeaturedProjects: (post) => dispatch(actions.getResFeaturedProjects(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(FeaturedProjectResidential);